import dayjs, { Dayjs } from "dayjs";

export const getEndDate = (date: Date | Dayjs, duration: number) => {
  return dayjs(date).add(duration, "s").second(0);
};
